"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.magdalena.description': 'Voz grave y cálida con fuerza tranquila y sutileza.',
};
